import { render, staticRenderFns } from "./terminalAdmin.vue?vue&type=template&id=6b7a246c&scoped=true"
import script from "./terminalAdmin.vue?vue&type=script&lang=js"
export * from "./terminalAdmin.vue?vue&type=script&lang=js"
import style0 from "./terminalAdmin.vue?vue&type=style&index=0&id=6b7a246c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a246c",
  null
  
)

export default component.exports